import {
  ARTICLE_RIGHT_RAIL_PAGE_TYPE,
  ARTICLE_SLIDESHOW_PAGE_TYPE,
  ARTICLE_FULL_WIDTH_PAGE_TYPE
} from '../../constants';

// Tested via components/article_spec.js
export const ABOVE_ARTICLE_HEADER_AD_SIZES = [
  [728, 90],
  [970, 90]
];

// Tested via components/article/right_rail_ad_spec.js
export const RIGHT_RAIL_AD_SIZES = [
  [300, 250],
  [300, 600]
];

// Tested via components/ad/header_ad_spec.js
export const HEADER_AD_SIZES = {
  desktop: [
    [7, 7],
    [8, 8],
    [728, 90],
    [970, 90],
    [970, 250]
  ],
  tablet: [
    [7, 7],
    [8, 8]
  ],
  mobile: [
    [7, 7],
    [8, 8]
  ]
};

// Tested via components/ad/see_all_slides_ad_spec.js
export const SEE_ALL_SLIDES_AD_SIZES = [
  [10, 10],
  [300, 250],
  [728, 90],
  [970, 90],
  [970, 250]
];

export const getModuleAdSizes = (type, breakpoint) => {
  const moduleAdSizes = {
    aggregation: {
      desktop: [
        [10, 10],
        [970, 250],
        [970, 90],
        [728, 90],
        [1280, 90]
      ],
      tablet: [
        [10, 10],
        [728, 90],
        [300, 250]
      ],
      mobile: [
        [10, 10],
        [300, 50],
        [300, 90],
        [300, 250],
        [320, 50]
      ]
    },
    'related-content': {
      desktop: [
        [10, 10],
        [300, 250],
        [728, 90],
        [970, 90],
        [970, 250],
        [1280, 90]
      ],
      tablet: [
        [10, 10],
        [300, 250],
        [728, 90]
      ],
      mobile: [
        [10, 10],
        [300, 50],
        [300, 90],
        [300, 250]
      ]
    },
    'all-shows': {
      desktop: [],
      tablet: [],
      mobile: []
    }
  };

  return moduleAdSizes[type]
    ? moduleAdSizes[type][breakpoint]
    : moduleAdSizes.aggregation[breakpoint];
};

export const getSectionAdSizesForArticleType = (type) => {
  switch (type) {
    case ARTICLE_RIGHT_RAIL_PAGE_TYPE:
      return {
        desktop: [
          [1280, 90], [728, 90], [300, 250], [10, 10]
        ],
        tablet: [
          [728, 90], [300, 250], [10, 10]
        ],
        mobile: [
          [320, 50], [300, 250], [300, 50], [300, 90], [10, 10]
        ]
      };
    case ARTICLE_SLIDESHOW_PAGE_TYPE:
      return {
        desktop: [],
        tablet: [
          [728, 90], [300, 250], [10, 10]
        ],
        mobile: [
          [320, 50], [300, 250], [300, 50], [300, 90], [10, 10]
        ]
      };
    case ARTICLE_FULL_WIDTH_PAGE_TYPE:
      return {
        desktop: [
          [1280, 90], [970, 90], [970, 250], [728, 90], [300, 250], [10, 10]
        ],
        tablet: [
          [728, 90], [300, 250], [10, 10]
        ],
        mobile: [
          [320, 50], [300, 250], [300, 50], [300, 90], [10, 10]
        ]
      };
    case POST_ARTICLE_SLIDESHOW_PAGE_TYPE:
      return {
        desktop: [[970, 90], [970, 250], [728, 90], [300, 250], [10, 10]],
      };
    default:
      return {
        desktop: [
          [1280, 90], [728, 90], [300, 250], [7, 7], [8, 8], [10, 10]
        ],
        tablet: [
          [728, 90], [300, 250], [7, 7], [8, 8], [10, 10]
        ],
        mobile: [
          [320, 50], [300, 250], [300, 50], [300, 90], [7, 7], [8, 8], [10, 10]
        ]
      };
  }
};
